import notice from "./notice"
import Qs from 'qs'
import axios from 'axios';
import config from './common';
import units from './units';
import Vue from 'vue'
// 正在进行中的请求列表
let reqList = []

/**
 * 阻止重复请求
 * @param {array} reqList - 请求缓存列表
 * @param {string} url - 当前请求地址
 * @param {function} cancel - 请求中断函数
 * @param {string} errorMessage - 请求中断时需要显示的错误信息
 */
const stopRepeatRequest = function (reqList, url, cancel, errorMessage) {
  const errorMsg = errorMessage || ''
  for (let i = 0; i < reqList.length; i++) {
    if (reqList[i] === url) {
      cancel(errorMsg)
      return
    }
  }
  reqList.push(url)
}

/**
 * 允许某个请求可以继续进行
 * @param {array} reqList 全部请求列表
 * @param {string} url 请求地址
 */
const allowRequest = function (reqList, url) {
  for (let i = 0; i < reqList.length; i++) {
    if (reqList[i] === url) {
      reqList.splice(i, 1)
      break
    }
  }
}

// 请求拦截器
axios.interceptors.request.use(
  config => {
    let cancel
    // 设置cancelToken对象
    config.cancelToken = new axios.CancelToken(function (c) {
      cancel = c
    })
    // setTimeout(() => {
    //   const whiteUrl = ["/upload/common","/buz/organizationGroup/getSubGroup","/buz/offlinePolicy/mechan/addEnterPolicy"];
    //   if(whiteUrl.includes(config.url)){
    //     return;
    //   }
    //   // console.log(config.headers)
    //   if (config.headers['Content-Type'] == 'application/x-www-form-urlencoded;charset=utf-8') {
    //     // 阻止重复请求。当上个请求未完成时，相同的请求不会进行
    //     const url = `${config.url}${config.data}${Qs.stringify(config.params || {})}`
    //     stopRepeatRequest(reqList, url.trim(), cancel, config.url + '重复请求')
    //   } else {
    //     if (typeof config.data == 'object') {
    //       config.data = JSON.stringify(config.data)
    //     }
    //     // 阻止重复请求。当上个请求未完成时，相同的请求不会进行
    //     const url = `${config.url}${Qs.stringify(JSON.parse(config.data || "{}"))}${Qs.stringify(config.params || {})}`
    //     stopRepeatRequest(reqList, url.trim(), cancel, config.url + '重复请求')
    //   }
    // }, 0)
    return config
  },
  err => Promise.reject(err)
)

// 响应拦截器
axios.interceptors.response.use(
  response => {

    // console.log(response)
    // 增加延迟，相同请求不得在短时间内重复发送
    //判断response.config.data类型  文件上传为object
    let data = response.config.data
    let url = ''
    if (response.config.headers['Content-Type'] == 'application/x-www-form-urlencoded;charset=utf-8') {
      url = `${response.config.url}${data}${Qs.stringify(response.config.params || {})} `
      setTimeout(() => {
        allowRequest(reqList, url.trim())
      }, 1000)

    } else {
      if (typeof data == 'object') {
        data = JSON.stringify(data)
      }
      url = `${response.config.url}${Qs.stringify(JSON.parse(data || "{}"))}${Qs.stringify(response.config.params || {})} `
      setTimeout(() => {
        allowRequest(reqList, url.trim())
      }, 1000)
    }
    return response
  },
  err => {
    //关闭loading弹窗
    if (window.vm) {
      window.vm.$data.$root.$children[0].isShowLoading = false
    }
    return Promise.reject(err)
  }
)

function request(params) {
  if (!params.url && !params.href) return;
  return new Promise((resolve, reject) => {
    let data = getParams(params);
    let query = getQuerys(params.query);
    var root = ""; //获取基础域名
    let headers = params.headers || "";
    let method = 'POST';
    if (params.type) {
      method = params.type.toUpperCase();
    }
    if (params.href) {
      params.url = params.href
    }
    if(params.apiPermissionCode){
      headers == ""?headers = {}:'';
      headers.apiPermissionCode = params.apiPermissionCode;
    }
    let obj = {}
    if (!params.body) {
      obj = {
        method: method,
        url: params.url + query,
        data: method === 'POST' || method === 'PUT' || method === 'DELETE' ? data : null,
        params: method === 'GET' ? data : null,
        baseURL: root,
        headers: headers,
        onUploadProgress: params.onUploadProgress,
        responseType: params.responseType || '',
        /**end */
        withCredentials: true
      }
    } else {
      obj = {
        method: method,
        url: params.url + query,
        data: data,
        baseURL: root,
        headers: headers,
        onUploadProgress: params.onUploadProgress,
        responseType: params.responseType || '',
        /**end */
        withCredentials: true
      }
    }
    return axios(obj)
      .then(function (res) {
        let headerCheck = useHeader(res.headers);
        if (!headerCheck) {
          resolve(res.data);
          return;
        }
        if (params.forced) {
          if (params.All) {
            resolve(res)
          } else {
            resolve(res.data)
          }
          return;
        }
        let isErr = hasError(res.data, params);
        if (isErr) {
          reject(res.data)
        } else {
          if (params.responseType && params.responseType == 'blob') {
            resolve(res)
          } else {
            resolve(res.data)
          }
        }

      })
      .catch(function (err) {
        let res = err.response
        reject(err)
        if (res) {
          window.alert('api error, HTTP CODE: ' + res.status)
        }
      })

  });
};

function useHeader(header) {
  // 通过header判断是否授权
  if (API_CONFIG.CHANNEL != "EPPS") return true;
  if (header.authed == "n") {
    epps_login.init({
      env: 0
    });
    return false;
  }
  return true;
}

// 接口参数校验和转换
function getParams(params) {
  let result;
  if (params.data) {
    result = filterNull(params.data)
  }
  if (params.contentType == 'from') {
    result = getURLSearchParams(result)
  }
  return result;
}
// 拼接接口后缀参数
function getQuerys(data) {
  if (!data) return "";
  let query = "";
  _.forIn(data, function (value, key) {
    query += query ? `&${key}=${value}` : `?${key}=${value}`
  });
  return query;
}
//公共错误处理
function hasError(data, params) {
  if (params.responseType && params.responseType == 'blob') {
    return false
  }
  if (data.httpCode == 200 || data.httpCode == 1) {
    return false
  }
  if (data.httpCode == -1 || data.httpCode == 40400) {
    //登陆过期
    localStorage.removeItem('hasLogin')
    //iframe父页面跳转login
    units.goLogin();
    return true
  }
  if (data.httpCode == 403) {
    setLayer(data.data)
    return true;
  }
  if (data.httpCode > 300 && data.data) {
    setLayer(data.data.errorMsg)
    return true;
  } else {
    setLayer(data.msg)
    return true;
  }
}

function setLayer(msg) {
  notice.error(msg)
}
// 自定义判断元素类型JS
function toType(obj) {
  return ({}).toString.call(obj).match(/\s([a-zA-Z]+)/)[1].toLowerCase()
}
// 参数过滤函数
function filterNull(o) {
  for (var key in o) {
    if (o[key] === null) {
      delete o[key]
    }
    if (toType(o[key]) === 'string') {
      o[key] = o[key].trim()
    } else if (toType(o[key]) === 'object') {
      o[key] = filterNull(o[key])
    } else if (toType(o[key]) === 'array') {
      o[key] = filterNull(o[key])
    }
  }
  return o
}
// 表单提交字段转换
function getURLSearchParams(params) {
  // 参数转换
  if (!params) return;
  let param = new URLSearchParams();
  for (var i in params) {
    param.append(i, params[i])
  }
  return param
}

export default request
